import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModuleState, PageState} from './qs-checks-controlling-veranstaltung.reducer';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';


export const getModuleState = createFeatureSelector<ModuleState>('QsChecksControllingVeranstaltungPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);


export const getVeranstaltungUebersichtListe = createSelector(getPageState, (state: PageState) => {
    const retListe: Array<ListInputItem> = [];

    if (state.veranstaltungUebersicht === null) {
        return [];
    }

    state.veranstaltungUebersicht.item_liste.forEach((item) => item.prueflauf_liste.map((prueflauf) => {
        retListe.push(<ListInputItem>{
            groupId: item.pruefer_rolle.rolle.rolle_id + item.pruefer_rolle.funktionsbereich.funktionsbereich_id,
            groupTitle: item.pruefer_rolle.rolle.titel + ' (' + item.pruefer_rolle.funktionsbereich.titel + ')',
            group: item,
            itemId: prueflauf.prueflauf_id,
            itemTitle: prueflauf.pruefobjekt_titel,
            item: prueflauf
        });
    }));

    return retListe;
});
export const getVeranstaltungUebersicht = createSelector(getPageState, (state: PageState) => state.veranstaltungUebersicht);
export const getVeranstaltungUebersichtLaden = createSelector(getPageState, (state: PageState) => state.veranstaltungUebersichtLaden);
export const getVeranstaltungUebersichtFehler = createSelector(getPageState, (state: PageState) => state.veranstaltungUebersichtFehler);

export const getAktuellenPrueflauf = createSelector(getPageState, (state: PageState) => state.aktuellerPrueflauf);

export const getPrueflaufDetail = createSelector(getPageState, (state: PageState) => state.prueflaufDetail);

export const getPrueflaufDetailListe = createSelector(getPageState, (state: PageState) => {
    const retListe: Array<ListInputItem> = [];

    if (state.prueflaufDetail === null) {
        return [];
    }

    state.prueflaufDetail.checklisten.forEach((checkliste) => checkliste.aufgaben.map((aufgabe) => {
        retListe.push(<ListInputItem>{
            groupId: checkliste.pruefcheckliste_id,
            groupTitle: checkliste.titel,
            group: checkliste,
            itemId: aufgabe.pruefaufgabe_id,
            itemTitle: aufgabe.titel,
            item: aufgabe
        });
    }));

    return retListe;
});

export const getPrueflaufDetailLaden = createSelector(getPageState, (state: PageState) => state.prueflaufDetailLaden);
export const getPrueflaufDetailFehler = createSelector(getPageState, (state: PageState) => state.prueflaufDetailFehler);

export const getAktuellePruefaufgabe = createSelector(getPageState, (state: PageState) => state.aktuellePruefaufgabe);
